export default __webpack_public_path__ + "static/startup-logo-0d802762e5550d00828962e381150fa4.svg";